// extracted by mini-css-extract-plugin
module.exports = {"pagination":"Paginator_pagination__1asUZ","active":"Paginator_active__3mj3D"};